import { EdlTokenPayload } from '../../model/edl-token-payload.model';
import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { ApplicationTypes, EdlAuth } from '@edl-development/edl-common';
import { PAETEPRoleType } from '../../model/enum/paetep-role-types.enum';

@Injectable()
export class SecurityService {
    private _token: string | null = null;
    private payload?:EdlTokenPayload;
    private validState:boolean = true;

    constructor(private _jwtHelper: JwtHelperService) {

    }

    Initialize(payload: EdlAuth) {

        this._token = payload.token;
        this.payload = this._jwtHelper.decodeToken(this._token) as EdlTokenPayload;

        if (this.payload.applicationId != ApplicationTypes.EDL_PAETEP) {
            this.validState = false;
        }

        if(!(this.payload?.roleIds ?? []).includes(PAETEPRoleType.Super_Admin)){
            if(this.payload.userName != payload.currentUser.Username){
             this.validState = false;
            }
            //more use cases in the future
        }

        return this.validState;
    }
}
